import React from "react";
import "./footer.css";
function Footer() {
  return null;
}

export default Footer;